import React, { useEffect, useState } from "react";
import { InputProps } from "./InputProps";
import { kgToPounds, poundsToKg } from "../../utils";
import TextInput from "./TextInput";
import { MeasuringSystem } from "../../types";
import { useApi } from "../../contexts/ApiContext";

interface WeightInputProps extends Omit<InputProps, "onChange"> {
  system: MeasuringSystem;
  onChange: (value: number | null) => void;
  value: number | null;
  id?: string;
}

const WeightInput: React.FC<WeightInputProps> = ({
  system,
  onChange,
  value,
  error,
  helperText,
  label,
  id,
}) => {
  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;
  const [inputValue, setInputValue] = useState<number | null>(
    value
      ? system === "imperial"
        ? parseInt(kgToPounds(value).toFixed(0))
        : value
      : null
  );

  const handleChange = (value: number) => {
    if (value === null) {
      setInputValue(null);
      onChange(null);
      return;
    }
    const weightInKg =
      system === "imperial"
        ? parseInt(poundsToKg(value).toFixed(0))
        : parseInt(value.toFixed(0));

    setInputValue(parseInt(value.toFixed(0)));
    onChange(weightInKg);
  };

  return (
    <TextInput
      disabled={isDisabled}
      id={id}
      label={label}
      type="integer"
      adornment={system === "imperial" ? "lb" : "kg"}
      value={inputValue}
      onChange={(value: number | string) => handleChange(value as number)}
      error={error}
      helperText={helperText}
      isRequired={true}
    />
  );
};

export default WeightInput;
